import { FileDownloadOutlined, SettingsBackupRestore } from '@mui/icons-material'
import { Button, FormControl, IconButton, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { map } from 'lodash'
import { FormFieldLabel } from '../../components/form/FormFieldLabel'
import { GLA_STRATEGIC_PRIORITY_LABEL } from './summaryByOUConstants'
import styles from './AdoptionDashboard.module.css'

interface SummaryByOUFilterBarProps {
  periods: { value: string; label: string }[] | undefined
  selectedPeriod: string
  selectedTitle: string
  selectedBPD: string
  selectedYear: number
  titles: string[] | undefined
  decodedLearnings: string[] | undefined
  exportDisabled: boolean
  onPeriodChange: (period: string) => void
  onTitleChange: (title: string) => void
  onBPDChange: (bpd: string) => void
  onResetFilters: () => void
  onExport: () => void
}

const SummaryByOUFilterBar = ({
  periods,
  selectedPeriod,
  selectedTitle,
  selectedBPD,
  selectedYear,
  titles,
  decodedLearnings,
  exportDisabled,
  onPeriodChange,
  onTitleChange,
  onBPDChange,
  onResetFilters,
  onExport,
}: SummaryByOUFilterBarProps) => (
  <div className={styles.summaryByOUFilters}>
    <div className={styles.summaryByOUFilterItem}>
      <FormFieldLabel
        text="Period"
        isAiGenerated={false}
      />
      <FormControl fullWidth>
        <Select
          size="small"
          value={selectedPeriod}
          onChange={(e: SelectChangeEvent) => onPeriodChange(e.target.value)}>
          {map(periods, period => (
            <MenuItem
              key={period.value}
              value={period.value}>
              {period.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
    <div className={styles.summaryByOUFilterItem}>
      <FormFieldLabel
        text={GLA_STRATEGIC_PRIORITY_LABEL}
        isAiGenerated={false}
      />
      <FormControl fullWidth>
        <Select
          size="small"
          value={selectedTitle}
          onChange={(e: SelectChangeEvent) => onTitleChange(e.target.value)}
          displayEmpty>
          <MenuItem value="">All</MenuItem>
          {titles?.map(title => (
            <MenuItem
              key={title}
              value={title}>
              {title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
    <div className={styles.summaryByOUFilterItem}>
      <FormFieldLabel
        text="BPD"
        isAiGenerated={false}
      />
      <FormControl fullWidth>
        <Select
          size="small"
          value={selectedBPD}
          onChange={(e: SelectChangeEvent) => onBPDChange(e.target.value)}
          displayEmpty>
          <MenuItem value="">All</MenuItem>
          {decodedLearnings?.map(dl => (
            <MenuItem
              key={dl}
              value={dl}>
              {dl}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
    <div className={styles.summaryByOUActions}>
      <IconButton
        onClick={onResetFilters}
        size="small"
        title="Reset filters">
        <SettingsBackupRestore />
      </IconButton>
      <Button
        className={styles.summaryByOUExportButton}
        onClick={onExport}
        disabled={exportDisabled}
        variant="contained"
        startIcon={<FileDownloadOutlined />}>
        <p className={styles.summaryByOUExportButtonText}>Export</p>
      </Button>
    </div>
  </div>
)

export default SummaryByOUFilterBar
